export enum RoutesUrl {
  Home = '/',
  Logout = '/logout',
  Library = '/library',
  Materials = '/materials',
  Backpack = '/backpack',
  Chat = '/chat',
  ChatRestart = '/chat/:restart?',
  Xpeditions = '/xpedition',
  Xpedition = '/xpedition/:xpeditionId/:restart?',
  Settings = '/settings',
  Content = '/content',
  PublicContent = '/public-content',
  Callback = '/callback',
  Dialogues = '/dialogues',
  Dialogue = '/dialogue/:dialogueId',
  Article = '/article/:articleId',
  ArticleAuthors = '/article/authors/:articleId',
  ReferenceAuthors = '/article/reference/authors/:articleId/:referenceId',
  ArticleReferences = '/article/references/:articleId',
  ArticleReference = '/article/reference/:articleId/:referenceId',
  ArticleSection = '/article/section/:articleId/:sectionIndex',
  ArticleSections = '/article/sections/:articleId',
  Resource = '/resource',
  About = '/content#4714',
  Journals = '/journals',
  Journal = '/journal/:journalId',
  Reviews = '/reviews',
  Review = '/review/:reviewId',
  References = '/content#5054',
  Chatroom = '/chatroom',
  ChatroomChat = '/chatroom/:dialogueId',
  CmResource = '/cmresource',
  CmResourceCard = '/cmresource/:srvId',
  Referrals = '/referrals',
  CmResourceOrganization = '/cmresource/org/:orgId',
  Search = '/search',
  SearchDialogue = '/search/:dialogueId',
  Trainings = '/trainings',
  TrainingsChat = '/trainings/:dialogueId',
  Exercise = '/exercise',
  ExerciseChat = '/exercise/:dialogueId',
  AccessDenied = '/access-denied',
}

export enum TranslationKeys {
  Library = 'library',
  Materials = 'materials',
  Backpack = 'backpack',
  Chat = 'chat',
  Settings = 'user-settings',
  Content = 'content-page',
  Error = 'error',
  Footer = 'footer',
  Common = 'common',
  Home = 'home',
  Toasts = 'toasts',
  Dialogues = 'dialogues',
  Dialogue = 'dialogue',
  Article = 'article',
  About = 'about',
  Journals = 'journals',
  Resource = 'resource',
  Reviews = 'reviews',
  References = 'references',
  Chatroom = 'chatroom',
  CmResource = 'cmresource',
  Referrals = 'referrals',
  Search = 'search',
  Trainings = 'trainings',
  Exercise = 'exercise',
}

export const firstAuthorizedRoute = RoutesUrl.Chat;

export const routeTranslationKeys: { [key: string]: string } = {
  [RoutesUrl.Library]: TranslationKeys.Library,
  [RoutesUrl.Materials]: TranslationKeys.Materials,
  [RoutesUrl.Backpack]: TranslationKeys.Backpack,
  [RoutesUrl.Chat]: TranslationKeys.Chat,
  [RoutesUrl.ChatRestart]: TranslationKeys.Chat,
  [RoutesUrl.Xpeditions]: TranslationKeys.Chat,
  [RoutesUrl.Xpedition]: TranslationKeys.Chat,
  [RoutesUrl.Settings]: TranslationKeys.Settings,
  [RoutesUrl.Content]: TranslationKeys.Content,
  [RoutesUrl.Dialogues]: TranslationKeys.Dialogues,
  [RoutesUrl.Dialogue]: TranslationKeys.Dialogue,
  [RoutesUrl.Resource]: TranslationKeys.Resource,
  [RoutesUrl.About]: TranslationKeys.Content,
  [RoutesUrl.Journals]: TranslationKeys.Journals,
  [RoutesUrl.Reviews]: TranslationKeys.Reviews,
  [RoutesUrl.References]: TranslationKeys.Content,
  [RoutesUrl.Chatroom]: TranslationKeys.Chatroom,
  [RoutesUrl.ChatroomChat]: TranslationKeys.Chatroom,
  [RoutesUrl.CmResource]: TranslationKeys.CmResource,
  [RoutesUrl.Referrals]: TranslationKeys.Referrals,
  [RoutesUrl.Search]: TranslationKeys.Search,
  [RoutesUrl.Trainings]: TranslationKeys.Trainings,
  [RoutesUrl.Exercise]: TranslationKeys.Exercise
};
